import { createContext, useContext, useEffect, useState } from 'react';

const dict = {
  fr: {
    live_now: 'EN DIRECT',
    ended: 'Terminé',
    home: 'Accueil',
    lives: 'Lives',
    seller_dashboard: 'Espace Vendeur',
    buyer_dashboard: 'Mes Achats',
    admin_dashboard: 'Admin',
    login: 'Connexion',
    register: 'Inscription',
    logout: 'Déconnexion',
    email: 'Email',
    password: 'Mot de passe',
    name: 'Nom',
    role: 'Rôle',
    buyer: 'Acheteur',
    seller: 'Vendeur',
    google_login: 'Continuer avec Google',
    or: 'ou',
    hero_title: 'Tout s\'achète en direct',
    hero_sub: "Rejoins un live, enchérit en temps réel et gagne des pièces uniques — mode, beauté, électronique, maison et bien plus. Les vendeurs proposent tout produit légal, à prix imbattables.",
    watch_live: 'Voir le live',
    place_bid: 'ENCHÉRIR',
    current_price: 'Prix actuel',
    top_bidder: 'Meilleur enchérisseur',
    time_left: 'Temps restant',
    no_bids: 'Aucune enchère — soyez le premier !',
    chat: 'Chat',
    type_message: 'Écrivez un message…',
    send: 'Envoyer',
    ended_winner: 'Gagnant',
    my_wins: 'Mes enchères gagnées',
    my_products: 'Mes produits',
    my_lives: 'Mes lives',
    my_sales: 'Mes ventes',
    add_product: 'Ajouter un produit',
    start_live: 'Lancer un live',
    launch_auction: 'Lancer une enchère',
    product_name: 'Nom du produit',
    starting_price: 'Prix de départ (FCFA)',
    increment: 'Incrément (FCFA)',
    duration: 'Durée (sec)',
    image_url: 'URL image',
    stream_url: 'Lien du flux (admin uniquement)',
    live_title: 'Titre du live',
    description: 'Description',
    create: 'Créer',
    status: 'Statut',
    won: 'Gagné',
    payment_submitted: 'Paiement soumis',
    paid: 'Payé',
    delivered: 'Livré',
    shipped: 'Expédiée',
    pay_now: 'Payer maintenant',
    payment_instructions: 'Instructions de paiement',
    wave_pay: 'Payer avec Wave',
    om_pay: 'Payer avec Orange Money',
    transaction_id: 'ID de transaction',
    submit_payment: 'Envoyer la preuve',
    confirm_payment: 'Confirmer paiement',
    mark_delivered: 'Marquer comme livré',
    pending_sellers: 'Vendeurs en attente',
    approve: 'Approuver',
    suspend: 'Suspendre',
    stats: 'Statistiques',
    outbid_toast: 'Vous avez été dépassé !',
    won_toast: 'Bravo, vous avez gagné !',
    live_ended: 'Live terminé',
    viewers: 'spectateurs',
    time_extended: '+10s ajoutés !',
    seller_pending: 'Compte vendeur en attente de validation par un admin',
    payment_deadline: 'Payez avant',
    copy: 'Copier',
    copied: 'Copié !',
    price_step: 'Enchère minimale',
    notifications: 'Notifications',
    no_notifications: 'Aucune notification',
    all_lives: 'Tous les lives',
    join_live: 'Rejoindre',
  },
  en: {
    live_now: 'LIVE',
    ended: 'Ended',
    home: 'Home',
    lives: 'Lives',
    seller_dashboard: 'Seller Space',
    buyer_dashboard: 'My Orders',
    admin_dashboard: 'Admin',
    login: 'Sign in',
    register: 'Sign up',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    role: 'Role',
    buyer: 'Buyer',
    seller: 'Seller',
    google_login: 'Continue with Google',
    or: 'or',
    hero_title: 'Everything sells live',
    hero_sub: 'Join a live show, bid in real time and win unique items — fashion, beauty, electronics, home & more. Sellers can list any legal product at unbeatable prices.',
    watch_live: 'Watch live',
    place_bid: 'BID',
    current_price: 'Current price',
    top_bidder: 'Top bidder',
    time_left: 'Time left',
    no_bids: 'No bids yet — be the first!',
    chat: 'Chat',
    type_message: 'Type a message…',
    send: 'Send',
    ended_winner: 'Winner',
    my_wins: 'My won auctions',
    my_products: 'My products',
    my_lives: 'My lives',
    my_sales: 'My sales',
    add_product: 'Add product',
    start_live: 'Start a live',
    launch_auction: 'Launch auction',
    product_name: 'Product name',
    starting_price: 'Starting price (FCFA)',
    increment: 'Increment (FCFA)',
    duration: 'Duration (sec)',
    image_url: 'Image URL',
    stream_url: 'Stream link (admin only)',
    live_title: 'Live title',
    description: 'Description',
    create: 'Create',
    status: 'Status',
    won: 'Won',
    payment_submitted: 'Payment submitted',
    paid: 'Paid',
    delivered: 'Delivered',
    shipped: 'Shipped',
    pay_now: 'Pay now',
    payment_instructions: 'Payment instructions',
    wave_pay: 'Pay with Wave',
    om_pay: 'Pay with Orange Money',
    transaction_id: 'Transaction ID',
    submit_payment: 'Submit proof',
    confirm_payment: 'Confirm payment',
    mark_delivered: 'Mark delivered',
    pending_sellers: 'Pending sellers',
    approve: 'Approve',
    suspend: 'Suspend',
    stats: 'Stats',
    outbid_toast: 'You have been outbid!',
    won_toast: 'You won!',
    live_ended: 'Live ended',
    viewers: 'viewers',
    time_extended: '+10s added!',
    seller_pending: 'Seller account pending admin approval',
    payment_deadline: 'Pay before',
    copy: 'Copy',
    copied: 'Copied!',
    price_step: 'Min bid step',
    notifications: 'Notifications',
    no_notifications: 'No notifications',
    all_lives: 'All lives',
    join_live: 'Join',
  },
};

const Ctx = createContext({ lang: 'fr', t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('lang') || 'fr');
  useEffect(() => { localStorage.setItem('lang', lang); }, [lang]);
  const setLang = (l) => setLangState(l);
  const t = (k) => (dict[lang] && dict[lang][k]) || k;
  return <Ctx.Provider value={{ lang, t, setLang }}>{children}</Ctx.Provider>;
}
export const useI18n = () => useContext(Ctx);
